var _defs, _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _path3, _rect6, _rect7, _rect8, _path4, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeplrAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 103 98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-5,.cls-8{fill:#fff;}.cls-1,.cls-2,.cls-4,.cls-8{stroke:#d5dbe9;}.cls-2,.cls-4{fill:#eef1fa;}.cls-2,.cls-3,.cls-8{fill-rule:evenodd;}.cls-6{fill:#d5dbe9;}.cls-7{fill:#007dd5;}.cls-9{fill:url(#radial-gradient);}.cls-10{fill-opacity:0.57;fill:url(#radial-gradient-2);}.cls-11{fill-opacity:0.68;fill:url(#radial-gradient-3);}.cls-12{fill-opacity:0.08;fill:url(#radial-gradient-4);}.cls-13{fill-opacity:0.03;fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -512.84,
    cy: 351.64,
    r: 1.72,
    gradientTransform: "matrix(16, 0, 0, -16, 8276, 5632)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f80f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a942b5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -513.75,
    cy: 351.73,
    r: 1.59,
    gradientTransform: "matrix(16, 0, 0, -16, 8276, 5632)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#45f9de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a942b5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -512.75,
    cy: 350.75,
    r: 0.96,
    gradientTransform: "matrix(16, 0, 0, -16, 8276, 5632)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e957c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ac43b6",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a942b5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -513.25,
    cy: 351.25,
    r: 0.58,
    gradientTransform: "matrix(16, 0, 0, -16, 8276, 5632)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -512.89,
    y1: 351.03,
    x2: -513.83,
    y2: 351.62,
    gradientTransform: "matrix(16, 0, 0, -16, 8276, 5632)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: 15.5,
    width: 78,
    height: 57,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75,24.5A3.52,3.52,0,0,1,78.5,28h0v7.5H.5V28a3.44,3.44,0,0,1,1-2.47A3.44,3.44,0,0,1,4,24.5H75Z",
    transform: "translate(0 -9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5,28.2a2,2,0,1,1-2,2A2,2,0,0,1,5,28.2Zm5,0a2,2,0,1,1-2,2A2,2,0,0,1,10,28.2Zm5,0a2,2,0,1,1-2,2A2,2,0,0,1,15,28.2Z",
    transform: "translate(0 -9)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 45.5,
    y: 22.5,
    width: 57,
    height: 75,
    rx: 4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 62,
    y: 48,
    width: 34,
    height: 4,
    rx: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 52,
    y: 47,
    width: 6,
    height: 6,
    rx: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 53,
    y: 58,
    width: 4,
    height: 4,
    rx: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M54.55,60.92l2.88-3.08a.3.3,0,0,0,0-.38l-.36-.38a.23.23,0,0,0-.35,0l-2.35,2.51-1.09-1.17a.23.23,0,0,0-.35,0l-.36.38a.3.3,0,0,0,0,.38l1.63,1.74A.23.23,0,0,0,54.55,60.92Z",
    transform: "translate(0 -9)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 62,
    y: 58,
    width: 34,
    height: 4,
    rx: 1
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 52,
    y: 82.83,
    width: 16,
    height: 9.09,
    rx: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 76,
    y: 82.83,
    width: 20,
    height: 9.09,
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M99,31.5a3.52,3.52,0,0,1,3.5,3.5h0v7.5h-57V35A3.52,3.52,0,0,1,49,31.5H99Z",
    transform: "translate(0 -9)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 8
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 56,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 56,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 56,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 56,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 56,
    y: 4,
    width: 16,
    height: 16,
    rx: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "61.63 17.6 61.63 12.64 66.32 17.6 68.93 17.6 68.93 17.47 63.54 11.82 68.51 6.46 68.51 6.4 65.89 6.4 61.63 11.14 61.63 6.4 59.52 6.4 59.52 17.6 61.63 17.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeplrAccess);
export default __webpack_public_path__ + "static/media/keplr-access.fe83326abe8f2bc72cf526b2b02c8621.svg";
export { ForwardRef as ReactComponent };